import { useEffect, useRef } from 'react';
import TwoFactorForm from '../../components/verify-two-factor/verify-two-factor';
import useVerifyTwoFactor from './hooks/use-verify-two-factor';

const TwoFactor = () => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const { onSubmit, errors, control, isLoading, globalError } =
    useVerifyTwoFactor();

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  return (
    <TwoFactorForm
      onSubmit={onSubmit}
      errors={errors}
      control={control}
      requestInProgress={isLoading}
      globalError={globalError}
      inputRef={inputRef}
    />
  );
};

export default TwoFactor;
